// Feature: real individual identity (0022). Email one-time-code sign-in for invited people,
// the account header control, the route guard for both build modes, and People & access.
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { env } from '@/lib/env'
import { signInRoute } from '@/lib/identity'
import { useSession } from '@/lib/queries'

export { AccountMenu, IdentityControl } from './AccountMenu'
export { PeoplePage } from './PeoplePage'
export { AccountSignInExpired, CodeSignInForm, SignInPage } from './SignIn'

/**
 * Every data page needs a signed-in identity: a persona session in the demo (otherwise
 * /demo), a real account otherwise (otherwise /sign-in, returning here afterwards).
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const s = useSession()
  const location = useLocation()
  const to = signInRoute({ mode: env.mode, sandboxCode: s.sandboxCode, activePersona: s.activePersona, account: s.account })
  if (to === '/sign-in') return <Navigate to={`/sign-in?next=${encodeURIComponent(location.pathname + location.search)}`} replace />
  if (to) return <Navigate to={to} replace />
  return <>{children}</>
}

/** The demo page exists only in the demo; account builds send it to sign-in. */
export function DemoRoute({ children }: { children: ReactNode }) {
  if (env.mode !== 'synthetic_demo') return <Navigate to="/sign-in" replace />
  return <>{children}</>
}
